import { TimeTracking } from "~/components/staff/timetracking";

export const TimeTrackingScreen = () => {
  return <TimeTracking />;
};
